import { DateTime } from "luxon"
import { useListAvailabilitiesCalendar } from "@/composables/availability"
import { useListAppointmentRequests } from "@/modules/appointments/composables/appointment-requests"
import { useListAsyncAppointments } from "@/modules/async-appointment/composables/async-appointments"
import { AppointmentRequestStatusEnum } from "@vitable/asclepius-api-client-ts"

const state = () => ({
  pendingAppointmentRequestsCount: 0,
  pendingAsyncAppointmentsCount: 0,
  overdueAppointmentsCount: 0
})

const getters = {
  pendingAppointmentRequestsCount: (state: any) => {
    return state.pendingAppointmentRequestsCount
  },
  pendingAsyncAppointmentsCount: (state: any) => {
    return state.pendingAsyncAppointmentsCount
  },
  overdueAppointmentsCount: (state: any) => {
    return state.overdueAppointmentsCount
  }
}
const actions = {
  async getOverdueAppointmentsCount({ commit }: any) {
    const { listAvailabilitiesCalendar, calendarAvailabilities } = useListAvailabilitiesCalendar()

    const request = {
      startDatetime: DateTime.now().minus({ days: 30 }).toString(),
      endDatetime: DateTime.now().minus({ hour: 12 }).toString(),
      onlyScheduledIn: true,
      onlyActiveIn: true
    }

    try {
      await listAvailabilitiesCalendar(request)
      commit("setOverdueAppointmentsCount", {
        count: calendarAvailabilities.value.length
      })
    } catch (e) {
      console.error(`Failed to getOverdueAppointmentsCount - ${e}`)
      throw e
    }
  },
  async getPendingAppointmentRequestsCount({ commit }: any) {
    const { listAppointmentRequests, appointmentRequests } = useListAppointmentRequests()

    try {
      await listAppointmentRequests({ appointmentRequestStatus: AppointmentRequestStatusEnum.Pending })

      commit("setPendingAppointmentRequestsCount", {
        count: appointmentRequests.totalCount
      })
    } catch (e) {
      console.error(`Failed to getPendingAppointmentRequestsCount - ${e}`)
      throw e
    }
  },
  async getPendingAsyncAppointmentsCount({ commit }: any) {
    const { listAsyncAppointments, asyncAppointments } = useListAsyncAppointments()

    try {
      await listAsyncAppointments({ claimedIn: false, canceledIn: false })

      commit("setPendingAsyncAppointmentRequestsCount", {
        count: asyncAppointments.totalCount
      })
    } catch (e) {
      console.error(`Failed to getPendingAsyncAppointmentsCount - ${e}`)
      throw e
    }
  }
}

const mutations = {
  setOverdueAppointmentsCount(state: any, { count }: any) {
    state.overdueAppointmentsCount = count
  },
  setPendingAppointmentRequestsCount(state: any, { count }: any) {
    state.pendingAppointmentRequestsCount = count
  },
  setPendingAsyncAppointmentRequestsCount(state: any, { count }: any) {
    state.pendingAsyncAppointmentsCount = count
  }
}

export default {
  namespaced: true,
  getters,

  state,
  actions,
  mutations
}
